function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: -41.2083,
  y1: -45.221,
  x2: 561.1257,
  y2: 564.5041
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#FFB768"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF390F"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_1_)",
  d: "M400.5,512.1h-288c-61.6,0-112-50.4-112-112v-288c0-61.6,50.4-112,112-112h288c61.6,0,112,50.4,112,112v288 C512.5,461.7,462.1,512.1,400.5,512.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_8_",
  fill: "white",
  d: "M283.9,171.2c-9.5,0-17.2,7.3-17.2,16.3V227c0,5-4.6,9-10.3,9c-5.7,0-10.3-4-10.3-9v-53.7 c0-9-7.7-16.3-17.2-16.3c-9.5,0-17.2,7.3-17.2,16.3v43c0,5-4.6,9-10.3,9c-5.7,0-10.3-4-10.3-9v-15.6c0-9-7.7-16.3-17.2-16.3 c-9.5,0-17.2,7.3-17.2,16.3v36.9c0,5-4.6,9-10.3,9c-5.7,0-10.3-4-10.3-9v-4.3c0-9.4-7.7-17.1-17.2-17.1c-9.5,0-17.2,7.6-17.2,17.1 v51.2c0,9.4,7.7,17.1,17.2,17.1c9.5,0,17.2-7.7,17.2-17.1v-4.3c0-5,4.6-9,10.3-9c5.7,0,10.3,4,10.3,9v58.6c0,9,7.7,16.3,17.2,16.3 c9.5,0,17.2-7.3,17.2-16.3V259c0-5,4.6-9,10.3-9c5.7,0,10.3,4,10.3,9v40.2c0,9,7.7,16.3,17.2,16.3c9.5,0,17.2-7.3,17.2-16.3v-29.6 c0-5,4.6-9,10.3-9c5.7,0,10.3,4,10.3,9v31.6c0,9,7.7,16.3,17.2,16.3c9.5,0,17.2-7.3,17.2-16.3V187.5 C301.1,178.5,293.4,171.2,283.9,171.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_7_",
  fill: "white",
  d: "M338.9,215.3c-9.5,0-17.2,7.3-17.2,16.3v65c0,9,7.7,16.3,17.2,16.3c9.5,0,17.2-7.3,17.2-16.3 v-65C356.1,222.6,348.4,215.3,338.9,215.3"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_6_",
  fill: "white",
  d: "M393.8,248.3c-9.5,0-17.2,7.3-17.2,16.3v16.2c0,9,7.7,16.3,17.2,16.3c9.5,0,17.2-7.3,17.2-16.3 v-16.2C411,255.6,403.3,248.3,393.8,248.3"
}));

function SvgCastbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastbox);
export default __webpack_public_path__ + "static/media/castbox.5ed768f4.svg";
export { ForwardRef as ReactComponent };